// import axios from 'axios'

import { Get, getApiUrl, Post, Put } from '../api'
import {
  GET_ALL_TEMPLATES,
  GET_TEMPLATES,
  UPDATE_TEMPLATE,
  ADD_TEMPLATE,
} from '../types'
import { startLoading, stopLoading } from './loaderAction'


export const getAllTemplate = (query) => async (dispatch, getState) => {
  const { user } = getState().authReducer
  try {
    dispatch(startLoading())
    const res = await Post(
      // method: 'get',
      `${getApiUrl()}/templates/all`,
      query,
      user,
      // ...options,
    )
    if (res.success) {
      dispatch(stopLoading())
      dispatch({
        type: GET_ALL_TEMPLATES,
        payload: res?.data,
      })
    } else {
      dispatch(stopLoading())
      throw res.error.message
    }
    return Promise.resolve(res?.data)
  } catch (err) {
    dispatch(stopLoading())
    return Promise.reject(err)
  }
}

export const getTemplateDetails1 = (id) => async (dispatch, getState) => {
  const { user } = getState().authReducer
  try {
    dispatch(startLoading())
    const res = await Get(
      // method: 'get',
      `${getApiUrl()}/templates/${id}`,
      user,
      // ...options,
    )
    if (res.success) {
      dispatch(stopLoading())
      dispatch({
        type: GET_TEMPLATES,
        payload: res?.data,
      })
    } else {
      dispatch(stopLoading())
      throw res.error.message
    }
  } catch (err) {
    dispatch(stopLoading())
    return Promise.reject(err)
  }
}

export const addTemplate = (args) => async (dispatch, getState) => {
  const { user } = getState().authReducer
  try {
    dispatch(startLoading())
    const res = await Post(
      // method: 'post',
      `${getApiUrl()}/templates`,
      args,
      user,
      // ...options,
    )
    if (res.success) {
      dispatch(stopLoading())
      dispatch({
        type: ADD_TEMPLATE,
        payload: res?.data,
      })
    } else {
      dispatch(stopLoading())
      throw res.error.message
    }
  } catch (err) {
    dispatch(stopLoading())
    return Promise.reject(err)
  }
}

export const updateTemplate = (args) => async (dispatch, getState) => {
  try {
    dispatch(startLoading())
    const { user } = getState().authReducer
    const res = await Put(
      // method: 'put',
      `${getApiUrl()}/templates/${args.id}`,
      args,
      user,
      // ...options,
    )
    if (res.success) {
      dispatch(stopLoading())
      dispatch({
        type: UPDATE_TEMPLATE,
        payload: res?.data,
      })
    } else {
      dispatch(stopLoading())
      throw res.error.message
    }
  } catch (err) {
    dispatch(stopLoading())
    return Promise.reject(err)
  }
}
